<template>
	<div class="survey">
		<div class="survey-container mt-10">
			<div style="text-align: right; margin-top:-45px; margin-right:-45px;">
        <img
          width="119"
          :src="$apiUrl + '/storage/Bg8XEkf1nTHbNxaJ6KlBbu7t20s7HFkS8hVrhb7A.png'"
          alt=""
        />
			</div>

			<h2>Svenska Bostäder - Enkät</h2>
			<p><em>Kul att du vill svara, tack!</em></p>

			<h4 class="mb-3 mt-10">1. Vilket år är du född?</h4>
			<v-text-field hide-details solo v-model="yearOfBirth"></v-text-field>

			<h4 class="mb-3 mt-10">2. Är du man/kvinna/annat?</h4>
			<v-checkbox hide-details v-model="gender" value="Man" label="Man"></v-checkbox>
			<v-checkbox	hide-details v-model="gender" value="Kvinna" label="Kvinna"></v-checkbox>
			<v-checkbox	hide-details v-model="gender" value="Annat" label="Annat"></v-checkbox>

			<h4 class="mb-3 mt-10">3. Hur många personer ingår i ditt hushåll?</h4>
			<v-text-field hide-details solo v-model="personsInHoushold"></v-text-field>

			<h4 class="mb-3 mt-10">4. Hur länge har du bott i din nuvarande bostad?</h4>
			<v-text-field hide-details solo v-model="livedInHousehold"></v-text-field>

			<h4 class="mb-3 mt-6">5. Det är nära, enkelt och känns tryggt att ta avfallet från bostaden till miljörummet. <span style="font-weight:normal;">(på en skala från 1-7)</span></h4>
			<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="sbEaseOfRecycling"></vue-slider>
			<v-subheader>Kommentar</v-subheader>
  			<v-textarea rows="4" hide-details solo v-model="sbEaseOfRecyclingCommentary"></v-textarea>
			<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

			<h4 class="mb-3 mt-10">Till vilken grad uppfyllde våra produkter/tjänster era förväntningar?</h4>
			<vue-slider marks class="pb-10" :max="10" v-model="clientSatisfaction"></vue-slider>

			<h4 class="mb-3 mt-10">Vilka områden inom beteeendeförändring och nudging är ni intresserade av?</h4>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart mobilitet" label="Smart mobilitet"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart energianvändning" label="Smart energianvändning"></v-checkbox>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart vattenanvändning" label="Smart vattenanvändning"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart avfallshantering och återvinning" label="Smart avfallshantering och återvinning"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Smart matkonsumtion och mathantering" label="Smart matkonsumtion och mathantering"></v-checkbox>
			<v-checkbox hide-details v-model="clientNudgingInterest" value="Smart hälsofrämjande" label="Smart hälsofrämjande"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Höja kunskapen om nudging och beteendedesign i vår organisation" label="Höja kunskapen om nudging och beteendedesign i vår organistation"></v-checkbox>
			<v-checkbox	hide-details v-model="clientNudgingInterest" value="Other" label="Annat"></v-checkbox>
			<v-text-field v-if="clientNudgingInterest === 'Other'" v-model="clientNudgingInterestOther" label="Vänligen ange annat intresseområde"></v-text-field>

			<h4 class="mb-3 mt-6">Det är nära, enkelt och känns tryggt att ta avfallet från bostaden till miljörummet. <span style="font-weight:normal;">(på en skala från 1-7)</span></h4>
			<vue-slider class="pb-10" thumb-label="always" marks ticks="always" tick-size="4" :max="7" :min="1" v-model="sbEaseOfRecycling2"></vue-slider>

			<h4 class="mb-3 mt-10">Kommentarer <span style="font-weight:normal;">(Är det t.ex. något vi kan göra bättre? Eller var det något ni tyckte särskilt mycket om? Ej obligatorisk)</span></h4>
			<v-textarea rows="4" hide-details solo v-model="clientCommentary"></v-textarea>
			<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

			<div class="nudgd-btn inline survey-submit mt-10" @click="submitResponse()">
				Skicka svar
			</div>

			<div style="clear:both;"></div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import VueSlider from 'vue-slider-component'
	import 'vue-slider-component/theme/default.css'

  export default {
  	name: 'Vue',
  	components: {VueSlider},

  	mounted() {
  		this.uuid = Math.random().toString(36).substr(2, 5)
  		this.$store.state.surveyId = 7
  	},

  	data() {
  		return {
  			uuid: null,
  			yearOfBirth: null,
  			gender: null,
  			genderOther: null,
  			personsInHoushold: null,
  			livedInHousehold: null,
  			sbEaseOfRecycling: null,
  			sbEaseOfRecyclingCommentary: null,
  			clientSatisfaction: null,
  			clientNudgingInterest: null,
  			sbEaseOfRecycling2: null,
  			clientCommentary: null,
  		}
  	},

  		methods: {
  			saveState() {
  				axios.post(this.$apiUrl + '/api/survey/7', {
  					...this.$data, 
  					completed_pages: this.stepIndex,
  					seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
  					slug: this.$store.state.endUser?.slug
  				})
  			},

  			submitResponse() {
  				axios.post(this.$apiUrl + '/api/survey/7', {
  					...this.$data,
  					completed_pages: 4,
  					seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
  					complete: true,
  					slug: this.$store.state.endUser?.slug
  				}).then(res => {
  					this.$router.push({name: 'SurveyThanks'})
  	            })
  			}
  		},
  }
</script>
